// extracted by mini-css-extract-plugin
export default {"root":"LocalizedFileInput_root__yiS72","choose":"LocalizedFileInput_choose__EtkfN","input":"LocalizedFileInput_input__SO9Pf","selection":"LocalizedFileInput_selection__ECw1T"};